import React from 'react'

import MembershipSelection from './MembershipSelection'
import useTrackerHook from './useTrackerHook'
import useFormHook from './useFormHook'

const MembershipForm = ({
  isRenewingMembership = false,
  packages = [],
  tncUrl,
  track,
  userId,
}) => {
  const [state, dispatch] = useFormHook({
    isRenewingMembership,
    packages,
  })

  useTrackerHook({ state, track, userId })

  return (
    <React.Fragment>
      <div data-testid="membership-form">
        {state.currentStep === 'membershipSelection' && (
          <MembershipSelection
            dispatch={dispatch}
            isRenewingMembership={isRenewingMembership}
            state={state}
            tncUrl={tncUrl}
          />
        )}
      </div>
    </React.Fragment>
  )
}

export default React.memo(MembershipForm)
